const isDevelopment = import.meta.env.DEV;
// Get the hostname dynamically to support WSL development
const hostname = window.location.hostname;
const isLocalhost = ["localhost", "127.0.0.1"].includes(hostname);

const API_BASE_URL =
  import.meta.env.VITE_API_URL ||
  (isDevelopment ? `http://${isLocalhost ? "localhost" : hostname}:5000` : "");

export const AUTH_ENDPOINTS = {
  GOOGLE_LOGIN: `${API_BASE_URL}/auth/google`,
  LOGOUT: `${API_BASE_URL}/auth/logout`,
  CURRENT_USER: `${API_BASE_URL}/auth/current_user`,
  COMPLETE_FIRST_LOGIN: `${API_BASE_URL}/auth/complete-setup`,
  CHANGE_USERNAME: `${API_BASE_URL}/auth/change-username`,
};

export const API_ENDPOINTS = {
  // Vehicle endpoints
  VEHICLES: `${API_BASE_URL}/api/vehicles`,
  VEHICLE_BY_PLATE: (plate) => `${API_BASE_URL}/api/vehicles/plate/${plate}`,
  SUBMIT_VEHICLE_IMAGE: `${API_BASE_URL}/api/vehicles/submit-image`,
  DELETE_VEHICLE_IMAGE: (vehicleId, imageId) =>
    `${API_BASE_URL}/api/vehicles/${vehicleId}/images/${imageId}`,
  DELETE_VEHICLE: (vehicleId) => `${API_BASE_URL}/api/vehicles/${vehicleId}`,
  UPDATE_VEHICLE_PLATE: (vehicleId) =>
    `${API_BASE_URL}/api/vehicles/${vehicleId}/plate`,
  UPDATE_VEHICLE_PLATE_STYLE: (vehicleId) =>
    `${API_BASE_URL}/api/vehicles/${vehicleId}/plate-style`,
  TRENDING_VEHICLES: `${API_BASE_URL}/api/vehicles/trending`,
  TOP_VEHICLES: `${API_BASE_URL}/api/vehicles/top`,
  RECENT_VEHICLES: `${API_BASE_URL}/api/vehicles/recent`,
  LEADERBOARD: `${API_BASE_URL}/api/vehicles/leaderboard`,
  EXPLORE_VEHICLES: `${API_BASE_URL}/api/vehicles/explore`,
  VEHICLE_COUNT: `${API_BASE_URL}/api/vehicles/count`,
  VEHICLE_MAKES: `${API_BASE_URL}/api/vehicle-makes`,
  ADD_VEHICLE_TAG: (vehicleId) =>
    `${API_BASE_URL}/api/vehicles/${vehicleId}/tags`,
  REMOVE_VEHICLE_TAG: (vehicleId, tag) =>
    `${API_BASE_URL}/api/vehicles/${vehicleId}/tags/${tag}`,
  TOGGLE_VEHICLE_LIKE: (vehicleId) =>
    `${API_BASE_URL}/api/vehicles/${vehicleId}/like`,
  GET_VEHICLE_LIKE_STATUS: (vehicleId) =>
    `${API_BASE_URL}/api/vehicles/${vehicleId}/like`,
  OCR_PLATE: `${API_BASE_URL}/api/vehicles/ocr-plate`,
  QUICK_SUBMIT_PLATE: `${API_BASE_URL}/api/vehicles/quick-submit`,

  // User endpoints
  USERS: `${API_BASE_URL}/api/users`,
  USER_PROFILE: (username) => `${API_BASE_URL}/api/users/${username}`,
  USER_VEHICLES: (username) => `${API_BASE_URL}/api/users/${username}/vehicles`,
  USER_SEARCH: `${API_BASE_URL}/api/users/search`,
  CHANGE_USERNAME: `${API_BASE_URL}/api/auth/change-username`,
  UPLOAD_PROFILE_PIC: `${API_BASE_URL}/api/users/profile-pic`,

  // Announcements endpoint
  ANNOUNCEMENTS: `${API_BASE_URL}/api/announcements`,

  // Upload endpoints
  UPLOAD_FILE: `${API_BASE_URL}/api/upload/upload`,

  // Discussion endpoints
  DISCUSSIONS: `${API_BASE_URL}/api/discussions`,
  VEHICLE_DISCUSSIONS: (vehicleId) =>
    `${API_BASE_URL}/api/discussions/vehicle/${vehicleId}`,
  REPORT_COMMENT: (commentId) =>
    `${API_BASE_URL}/api/discussions/report/${commentId}`,
  GET_REPORTED_COMMENTS: `${API_BASE_URL}/api/discussions/reported`,
  MODERATE_COMMENT: (commentId) =>
    `${API_BASE_URL}/api/discussions/moderate/${commentId}`,

  // Admin endpoints for images
  REPORT_IMAGE: `${API_BASE_URL}/api/admin/report-image`,

  // Notification endpoints
  NOTIFICATIONS: `${API_BASE_URL}/api/notifications`,

  // Liked plates endpoint
  LIKED_PLATES: `${API_BASE_URL}/api/vehicles/liked`,

  REGENERATE_LICENSE_SNAPSHOT: `${API_BASE_URL}/api/users/regenerate-license-snapshot`,
};

export const ADMIN_ENDPOINTS = {
  GET_PENDING_IMAGES: `${API_BASE_URL}/api/admin/pending-images`,
  GET_REPORTED_IMAGES: `${API_BASE_URL}/api/admin/reported-images`,
  APPROVE_IMAGE: (vehicleId, imageId) =>
    `${API_BASE_URL}/api/admin/approve-image/${vehicleId}/${imageId}`,
  REJECT_IMAGE: (vehicleId, imageId) =>
    `${API_BASE_URL}/api/admin/reject-image/${vehicleId}/${imageId}`,
  REPORT_IMAGE: `${API_BASE_URL}/api/admin/report-image`,
  MODERATE_IMAGE: (vehicleId, imageId) =>
    `${API_BASE_URL}/api/admin/moderate-image/${vehicleId}/${imageId}`,
  RESTORE_VEHICLE: (vehicleId) =>
    `${API_BASE_URL}/api/admin/restore-vehicle/${vehicleId}`,
  MANAGE_STREAK_FREEZES: (userId) =>
    `${API_BASE_URL}/api/admin/users/${userId}/streak-freezes`,
};
